/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-11 19:21:05 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-11-15 11:30:26
 */
import { fetchTool } from "@/common/index";
import api from "./api";
let fetch = {}

for(let key in api) {
    fetch[key] = (params) => fetchTool.post(api[key], params);
}

export default fetch


// WEBPACK FOOTER //
// ./src/page/devDemo2/config/fetch.js